exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promos-rules-indicator,.promos-rules-indicator__item{display:flex;flex-direction:row;align-items:center}.promos-rules-indicator__item{margin-right:5px;font-weight:var(--font-weight-medium);font-style:normal;text-align:center;padding:3px 5px;border-radius:4px;font-size:var(--font-smallest)}.promos-rules-indicator__item.success{color:var(--green);background-color:var(--light-green)}.promos-rules-indicator__item.failure{color:var(--yellow);background-color:var(--light-yellow)}.promos-rules-indicator__item__icon{width:10px;margin-right:5px}.promos-rules-indicator-small{display:inline-block}", ""]);

// exports
